module.exports = __webpack_public_path__ + "img/print.32eaf1cd.svg";